import React, { useState, useEffect, useCallback, useRef } from 'react';

interface UndoToastState {
  message: string;
  onConfirm: () => void;
  id: number;
}

let _showUndoToast: ((message: string, onConfirm: () => void) => void) | null = null;

export const showUndoToast = (message: string, onConfirm: () => void) => {
  _showUndoToast?.(message, onConfirm);
};

const UndoToast: React.FC = () => {
  const [toast, setToast] = useState<UndoToastState | null>(null);
  const timerRef = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => {
    _showUndoToast = (message, onConfirm) => {
      if (timerRef.current) clearTimeout(timerRef.current);
      const id = Date.now();
      setToast({ message, onConfirm, id });
      timerRef.current = setTimeout(() => {
        setToast(prev => {
          if (prev?.id === id) {
            onConfirm();
            return null;
          }
          return prev;
        });
      }, 3000);
    };
    return () => { _showUndoToast = null; };
  }, []);

  const handleUndo = useCallback(() => {
    if (timerRef.current) clearTimeout(timerRef.current);
    setToast(null);
  }, []);

  if (!toast) return null;

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 'calc(var(--fh-nav-height, 72px) + env(safe-area-inset-bottom, 0px) + 12px)',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 9999,
        background: 'rgba(30,40,50,0.95)',
        color: '#fff',
        padding: '12px 16px',
        borderRadius: 14,
        fontSize: 13,
        fontWeight: 600,
        fontFamily: 'Manrope, sans-serif',
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        boxShadow: '0 8px 24px rgba(0,0,0,0.4)',
        backdropFilter: 'blur(8px)',
        maxWidth: 'calc(100vw - 32px)',
      }}
    >
      <span style={{ flex: 1 }}>{toast.message}</span>
      <button
        onClick={handleUndo}
        style={{
          background: 'none',
          border: 'none',
          color: '#ff8a65',
          fontWeight: 800,
          fontSize: 13,
          cursor: 'pointer',
          padding: '4px 8px',
          flexShrink: 0,
        }}
      >
        Undo
      </button>
    </div>
  );
};

export default UndoToast;
